import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { login, logout } from '../api/authApi';
import { User } from '../api/userApi/interfaces';
import { getCurrentUser } from '../api/userApi';

export const useGetCurrentUser = () => {
  return useQuery<User>({
    queryFn: getCurrentUser,
    queryKey: ['user'],
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export const useLogin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: login,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user'],
      });
    },
  });
};

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.setQueryData(['user'], null);
    },
  });
};
